import PropTypes from "prop-types";

/* Titled card used for every block in the profile content column. */
const Panel = ({ title, subtitle, actions, children, id }) => (
  <section className="c4prf__panel" aria-labelledby={id}>
    {title ? (
      <header className="c4prf__panel-head">
        <div>
          <h2 className="c4prf__panel-title" id={id}>
            {title}
          </h2>
          {subtitle ? <p className="c4prf__panel-sub">{subtitle}</p> : null}
        </div>
        {actions ? <div className="c4prf__panel-actions">{actions}</div> : null}
      </header>
    ) : null}

    {children}
  </section>
);

Panel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
  id: PropTypes.string,
};

export default Panel;
